__turbopack_context__.v({
  "blok-big-title": "skeleton-module__wazmZW__blok-big-title",
  "blok-subtitle": "skeleton-module__wazmZW__blok-subtitle",
  "blok-title": "skeleton-module__wazmZW__blok-title",
  "skeleton": "skeleton-module__wazmZW__skeleton",
});
